//extracted by mini-css-extract-plugin
export default {"container":"styles_container__tuAai","confirmationContent":"styles_confirmationContent__G0d-m"};;